import React from "react";
import { View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Skeletons from "../../Components/skeleton-components/Skeletons";

const StreamSetupSkeleton = ({ showLoader }) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  if (!showLoader) return null;

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        {/* Back Arrow and "Stream Setup" */}
        <Skeletons
          height={32}
          width={"150px"}
          style={{ borderRadius: 6, marginRight: 10 }}
          backgroundColor={AppColors.gray_C4C4C4}
        />
        <Skeletons
          height={40}
          width={"200px"}
          style={{ borderRadius: 10 }}
          backgroundColor={AppColors.gray_C4C4C4}
        />
      </View>
      {/* Main Content */}
      <View style={styles.content}>
        {/* Video Preview Area */}
        <View style={styles.videoPreviewcontainer}>
          <View style={styles.videoPreview}>
            <Skeletons
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 300
                  : 400
              }
              width="100%"
              style={{ borderRadius: 10 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          </View>
          <View>
            <Skeletons
              height={85}
              width={"100%"}
              style={{ borderRadius: 6, marginRight: 10 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          </View>
        </View>

        {/* Live Chat Section */}
        <View style={styles.chatSection}>
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 400
                : 500
            }
            width="100%"
            style={{ borderRadius: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>

        {/* Live Chat Section */}
        <View style={styles.chatSection}>
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 400
                : 500
            }
            width="100%"
            style={{ borderRadius: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>
      </View>
      {/* Three-Column Section */}
      <View style={styles.threeColumnSection}>
        {/* Sources Section */}
        <View style={styles.sourcesColumn}>
          <Skeletons
            height={250}
            width={"100%"}
            style={{ borderRadius: 6, marginBottom: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>
        {/* Desktop Audio Section */}
        {/* <View style={styles.audioColumn}>
          <Skeletons
            height={250}
            width={"100%"}
            style={{ borderRadius: 6, marginBottom: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View> */}
        {/* Controls Section */}
        <View style={styles.controlsColumn}>
          <Skeletons
            height={250}
            width={"100%"}
            style={{ borderRadius: 6, marginBottom: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: AppColors.black_121212,
      padding: 10,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingVertical: 5,
    },
    content: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 10,
    },
    videoPreview: {
      width: "100%",
      marginBottom: 10,
    },
    chatSection: {
      width: "25%",
    },
    chatTabs: {
      flexDirection: "row",
      marginBottom: 5,
    },

    videoPreviewcontainer: {
      flexDirection: "column",
      width: "46.5%",
    },
    threeColumnSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 10,
      height: 265,
    },
    sourcesColumn: {
      width: "73.2%",
    },
    sourceItem: {
      marginBottom: 10,
    },
    sourceIcons: {
      flexDirection: "row",
      marginTop: 5,
    },
    sourceButtons: {
      flexDirection: "row",
      marginTop: 10,
    },
    audioColumn: {
      width: "22%",
    },
    sliderItem: {
      marginBottom: 10,
    },
    sliderIcons: {
      flexDirection: "row",
      marginTop: 5,
    },
    controlsColumn: {
      width: "25%",
    },
    timer: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 10,
    },
    timerItem: {
      alignItems: "center",
    },
    timerLabel: {
      color: AppColors.white,
      fontSize: 12,
      marginBottom: 5,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        padding: 5,
      },
      header: {
        paddingVertical: 3,
      },
      content: { flexDirection: "column" },
      videoPreview: { width: "100%" },
      chatSection: { width: "100%", marginTop: 10 },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        padding: 8,
      },
      header: {
        paddingVertical: 4,
      },
      content: { flexDirection: "column" },
      videoPreview: { width: "100%" },
      chatSection: { width: "100%", marginTop: 10 },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        padding: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        padding: 12,
      },
    },
  }
);

export default StreamSetupSkeleton;
